import React, {PropTypes as T} from 'react';
import './caret.less';

export default class Caret extends React.Component {

    static propTypes = { 
        size: T.number.isRequired,
    };

    static defaultProps = {
        size: 20,
    };

	constructor(props) {
    	super(props);
  	}

  	render() {
  		return (
  			<div className="b3-caret" style={{ borderWidth: this.props.size / 2 }}></div>
  		);
  	}
}


// WEBPACK FOOTER //
// ./app/b3/misc/Caret.js